<app-card-header-loader *ngIf="(isLoading|async); else detailView"/>

<ng-template #detailView>
  <app-card [cardClasses]="'mb-8'" [header]="!!title" [cardHeaderTitle]="title" [cardBodyClasses]="'pt-0'">
    <ng-container cardBody>
      <div *ngIf="(data|async) as data" class="row align-items-start">
        <div class="col-12 col-md" *ngFor="let value of data">
          <div class="font-12 fw-semibold text-gray-500 mb-2">{{ value.name }}</div>
          <h1 class="text-gray-800">{{ value.value }}</h1>
        </div>
      </div>

      <div *ngIf="(dataSectionDefault | async) as dataSectionDefault" class="row align-items-start">
        <div class="col-12 col-md" *ngFor="let value of dataSectionDefault">
          <div class="font-12 fw-semibold text-gray-500 mb-2">{{ value.title }}</div>
          <div class=" fw-bold text-gray-800">{{ value.value }}</div>
          <div class="fw-bold text-gray-800">{{ value.description }}</div>
        </div>
      </div>
    </ng-container>
  </app-card>
</ng-template>
